import { render, staticRenderFns } from "./ClubLpuPriceSwitcher.vue?vue&type=template&id=5b28eed4&"
import script from "./ClubLpuPriceSwitcher.vue?vue&type=script&lang=js&"
export * from "./ClubLpuPriceSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./ClubLpuPriceSwitcher.vue?vue&type=style&index=0&id=5b28eed4&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b28eed4')) {
      api.createRecord('5b28eed4', component.options)
    } else {
      api.reload('5b28eed4', component.options)
    }
    module.hot.accept("./ClubLpuPriceSwitcher.vue?vue&type=template&id=5b28eed4&", function () {
      api.rerender('5b28eed4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Club/components/dependencies/ClubLpuPriceSwitcher/components/ClubLpuPriceSwitcher.vue"
export default component.exports